const ruleMixin = {
  data() {
    return {
      emailRule: [
        (v: string) => !!v || 'E-mail必填',
        (v: string) => /.+@.+/.test(v) || 'E-mail 格式錯誤',
      ],
      // 至少包含大寫、小寫、數字、特殊符號
      passwordRule: [
        (v: string) => !!v || '密碼 為必填',
        (v: string) => !v || /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&+=])[^]{6,}$/.test(v) || '密碼必須包含大小寫英文，數字及下列符號： @#$%^&+=',
      ],
      newPasswordRule: [
        (v: string) => !!v || '密碼 為必填',
        (v: string) => !v || /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&+=])[^]{6,}$/.test(v) || '密碼必須包含大小寫英文，數字及下列符號： @#$%^&+=',
      ],
      newTranPasswordRule: [
        (v: string) => !!v || '交易密碼 為必填',
        (v: string) => !v || /^\d{6}$/.test(v) || '密碼必須6碼數字',
      ],
      mobileRule: [
        (v: string) => !!v || '手機號碼 為必填',
        (v: string) => !v || /^09\d{8}/.test(v) || '手機號碼 格式錯誤',
      ],
      picRule: [
        (v: string) => !!v || '身分證字號 為必填',
        (v: string) => !v || /^[A-Za-z][12]\d{8}$/.test(v) || '身分證字號 格式錯誤',
      ],
    };
  },
  methods: {
    requiredRule(column: string) {
      return [
        (v: string) => (v !== null && v !== undefined && v !== '') || `${column} 為必填`,
      ];
    },
    maxLengthRule(column: string, length: number) {
      return [
        (v: any) => v?.length <= length || `${column} 最多 ${length} 字`,
      ];
    },
    lessThanRule(column: string, column2: string, val: any) {
      return [
        (v: any) => !v || !val || v < val || `${column} 必須小於 ${column2}`,
      ];
    },
    greaterThanRule(column: string, column2: string, val: any) {
      return [
        (v: any) => !v || !val || v > val || `${column} 必須大於 ${column2}`,
      ];
    },
  },
};

export default ruleMixin;
